import { useMyAttendance } from '@/features/student-attendance/hooks/useMyAttendance';
import { useStudentPayments } from '@/features/student-payments/hooks/useStudentPayments';
import { useMyRequests } from '@/features/student-requests/hooks/useMyRequests';
import { useMyClasses } from '@/features/student-requests/hooks/useMyClasses';
/** Aggregates the student's dashboard KPIs from the existing per-feature endpoints. */
export function useStudentDashboard() {
    const attendance = useMyAttendance();
    const payments = useStudentPayments();
    const requests = useMyRequests();
    const classes = useMyClasses();
    const records = attendance.data ?? [];
    const total = records.length;
    const present = records.filter((r) => r.status === 'present' || r.status === 'late').length;
    // Criterio único del % (2026-07-12): la justificada ni suma ni penaliza.
    const countable = records.filter((r) => r.status !== 'justified').length;
    const attendancePct = countable > 0 ? Math.round((present / countable) * 100) : null;
    const pendingPayments = (payments.data ?? []).filter((p) => p.status === 'pending' || p.status === 'overdue').length;
    const openRequests = (requests.data ?? []).filter((r) => r.status === 'pending').length;
    // Fecha local, no UTC: entre las 00:00 y la 01:00/02:00 la clase de ayer
    // aparecía como "próxima clase".
    const today = new Intl.DateTimeFormat('en-CA').format(new Date());
    const cls = classes.data ?? [];
    const future = cls.filter((c) => c.date >= today).sort((a, b) => a.date.localeCompare(b.date));
    const past = cls.filter((c) => c.date < today).sort((a, b) => b.date.localeCompare(a.date));
    return {
        attendancePct,
        totalClasses: total,
        pendingPayments,
        openRequests,
        nextClass: future[0] ?? null,
        lastClass: past[0] ?? null,
        isLoading: attendance.isLoading || payments.isLoading || requests.isLoading || classes.isLoading,
    };
}
//# sourceMappingURL=useStudentDashboard.js.map